const LinkType = {
  Home: 1, // 首页1
  AlwaysBuysList: 2, // 常购清单
  BrandMoreList: 3, // 品牌
  BuyCar: 4, // 购物车4
  Mine: 5, // 我的5
  MyOrder: 6, // 我的订单
  MyCollection: 7, // 我的收藏
  ApplyInvoice: 8, // 发票信息
  Feedback: 9, // 意见反馈
  MyQualifications: 10, // 我的资质
  Goods: 12, // 商品12
  Category: 11, // 商品分类？？？？这里应该使用运营分类
  // OperatingClassify: 11, // 运营分类
  ActivityGoodsView: 13, // 活动
  NewGoodsList: 14, // 新品抢购
  ArrivingSoonList: 15, // 即将到货
  VoucherCenter: 17, // 领券中心
  OrderDetails: 18, // 我的订单详情
  DtoProductList: 19, // 复杂商品列表
  ActivityView: 40, // 普通活动专区
  FactoryMoreList: 50, // 厂家
  SearchPage: 51, // 商品列表
  ProductDetails: 52, // 商品详情
  FactoryList: 53, // 厂家推荐
  HotSaleList: 54, // 热销专区
  BrandList: 55, // 品牌推荐
  StoreyProductList: 98, // 楼层更多
  Externally: 99, // 外部链接
  DisorderlyPrice: 100, // 乱价投诉
  ActivitySeckillView: 102 // 秒杀专区
  // SpecialOffer: 40 // 特价专区
}

const LinkTypeCode = {
  Home: '/', // 首页1
  AlwaysBuysList: 'AlwaysBuysList', // 常购清单
  Brand: 'Brand', // 品牌
  Mine: 'Mine', // 我的
  DownLoad: 'DownLoad', // APP下载页
  HelpCenter: 'HelpCenter', // 帮助中心
  MyOrder: 'MyOrder', // 我的订单
  MyCollection: 'MyCollection', // 我的收藏
  MyControlPin: 'MyControlPin', // 我的控销
  AddControlPinKind: 'AddControlPinKind', // 添加控销品种
  ApplyInvoice: 'ApplyInvoice', // 发票信息
  AddressShow: 'AddressShow', // 收货地址
  StoreInfo: 'StoreInfo', // 门店信息
  Feedback: 'Feedback', // 意见反馈
  FeedbackHistory: 'FeedbackHistory', // 意见反馈历史
  MyQualifications: 'MyQualifications', // 我的资质
  ProductDetails: 'ProductDetails', // 商品详情12
  ActivityAreaList: 'ActivityAreaList', // 活动——满赠专区
  ArrivingSoonList: 'ArrivingSoonList', // 即将到货列表
  OperatingClassify: 'OperatingClassify', // 运营分类
  SearchPage: 'SearchPage', // 商品列表
  BrokerageSelectPay: 'BrokerageSelectPay', // 券订单确认
  Category: 'Category', // 商品分类
  NewGoodsList: 'NewGoodsList', // 新品抢购
  BrandProductList: 'BrandProductList', // 品牌商品列表
  DisorderlyPrice: 'DisorderlyPrice', // 乱价投诉
  InterlockSettings: 'InterlockSettings', // 连锁设置
  BindGeneralStore: 'BindGeneralStore', // 连锁设置绑定总店
  ActivityView: 'ActivityView', // 活动专区
  ActivitySeckillView: 'ActivitySeckillView', // 活动专区-秒杀
  ActivityGiftView: 'ActivityGiftView', // 活动专区-满赠，换购
  ActivityGoodsView: 'ActivityGoodsView', // 活动商品列表

  Login: 'Login', // 登录
  BuyCar: 'BuyCar', // 购物车
  ConfirmOrder: 'ConfirmOrder', // 订单确认
  SelectPay: 'SelectPay',
  PaySuccess: 'PaySuccess',
  Msg: 'Msg', // 消息中心
  MyStore: 'MyStore', // 我的门店
  Goods: 'ProductDetails', // 商品详情
  BrokerageCity: 'BrokerageCity', // 券商城
  BrokerageDetail: 'BrokerageDetail', // 券详情
  OrderDetails: 'OrderDetails', // 我的订单详情
  OrderRefundDetails: 'OrderRefundDetails', // 订单详情，退款
  ViewLogistics: 'ViewLogistics',
  BrokerageConfirmOrder: 'BrokerageConfirmOrder', // 券 确认订单
  Pay: 'Pay',

  VoucherCenter: 'VoucherCenter', // 领券中心
  MyCoupon: 'MyCoupon', // 我的优惠券
  AfterSale: 'AfterSale', // 退款/售后
  StoreyProductList: 'StoreyGoodsList', // 楼层更多
  DtoProductList: 'DtoProductList', // 复杂商品列表（满减专区）

  SpecialOffer: 'SpecialOffer', // 特价专区
  ActivityProductList: 'ActivityProductList',
  NewGoodsCollect: 'NewGoodsCollect', // 新品收集
  ChildAccount: 'ChildAccount', // 子账号管理
  AddChildAccount: 'AddChildAccount', // 添加子账号
  FactoryList: 'FactoryList', // 厂家专区
  BrandList: 'BrandList', // FactoryMoreList
  FactoryMoreList: 'FactoryMoreList',
  BrandMoreList: 'BrandMoreList',
  HotSaleList: 'HotSaleList' // 热销专区
}

const LinkTitle = {
  Home: '首页', // 首页1
  AlwaysBuysList: '常购清单', // 常购清单
  Brand: '品牌', // 品牌
  Mine: '个人中心', // 我的
  DownLoad: 'APP下载页', // APP下载页
  HelpCenter: '帮助中心', // 帮助中心
  MyOrder: '我的订单', // 我的订单
  MyCollection: '我的收藏', // 我的收藏
  ApplyInvoice: '发票信息', // 发票信息
  AddressShow: '收货地址', // 收货地址
  StoreInfo: '门店信息', // 门店信息
  Feedback: '意见反馈', // 意见反馈
  BrokerageSelectPay: '选择支付方式',
  BrokerageConfirmOrder: '确认券订单',
  MyControlPin: '我的控销', // 我的控销
  AddControlPinKind: '添加控销品种', // 添加控销品种
  DisorderlyPrice: '乱价投诉', // 乱价投诉
  FeedbackHistory: '意见反馈历史', // 意见反馈历史
  MyQualifications: '我的资质', // 我的资质
  Goods: '商品详情', // 商品详情12
  ActivityAreaList: '满赠专区', // 活动——满赠专区
  NewProductList: '新品列表', // 新品列表
  ArrivingSoonList: '即将到货', // 即将到货列表
  OperatingClassify: 'ProductList/OperatingClassify', // 运营分类
  SearchPage: '商品列表', // 商品列表
  Category: '商品分类', // 商品分类
  NewGoodsList: '新品抢购', // 新品抢购
  BrandProductList: '商品列表', // 品牌商品列表

  Login: '登录', // 登录
  BuyCar: '购物车', // 购物车
  ConfirmOrder: '订单确认', // 订单确认
  SelectPay: '收银台',
  PaySuccess: '付款成功',
  Msg: '消息中心', // 消息中心

  ProductDetails: '商品详情', // 商品详情
  ActivityView: '促销', // 活动专区
  ActivitySeckillView: '秒杀', // 活动专区-秒杀
  ActivityGiftView: '促销', // 活动专区-满赠，换购
  ActivityGoodsView: '商品列表', // 活动商品列表
  BrokerageCity: '券商城',
  BrokerageDetail: '券详情',
  OrderDetails: '订单详情', // 我的订单详情
  OrderRefundDetails: '订单退款详情', // 订单详情，退款
  ViewLogistics: 'ViewLogistics',

  Pay: '支付',

  StoreyProductList: '商品列表', // 更多商品
  VoucherCenter: '领券中心', // 领券中心
  MyCoupon: '我的优惠券', // 我的优惠券
  DtoProductList: 'ProductList/DtoProductList', // 复杂商品列表（满减专区）

  SpecialOffer: '特价专区',
  ActivityProductList: '活动商品列表',
  AfterSale: '退款/售后',
  NewGoodsCollect: '新品收集', // 新品收集
  ChildAccount: '子账号管理', // 子账号管理
  AddChildAccount: '添加子账号',
  InterlockSettings: '连锁设置',
  BindGeneralStore: '绑定总店',
  FactoryList: '厂家专区', //
  BrandList: '品牌专区',
  FactoryMoreList: '厂家详情', // BrandMoreList
  BrandMoreList: '品牌详情',
  HotSaleList: '热销专区'
}
const version = 'v1.6.0'
export { LinkType, LinkTypeCode, LinkTitle, version }
